import { fetchQuery } from 'react-relay';

import { getRelayEnvironment } from '@confluence/graphql-provider/entry-points/relayEnvironment.ts';

import PageOwnershipByLineWithCollaboratorsDropdownContentQuery, {
	type PageOwnershipByLineWithCollaboratorsDropdownContentQuery as CollaboratorsQueryType,
} from './PageOwnershipByLineWithContributorsDropdown/__generated__/PageOwnershipByLineWithCollaboratorsDropdownContentQuery.graphql.ts';
import { getContentCollaboratorsQueryVariables } from './PageOwnershipByLineWithContributorsDropdown/getContentCollaboratorsQueryVariables.ts';

export const preloadContentOwnershipCollaborators = ({
	cloudId,
	contentId,
	spaceKey,
}: {
	cloudId: string;
	contentId: string;
	spaceKey: string;
}): Promise<CollaboratorsQueryType['response'] | undefined> =>
	fetchQuery<CollaboratorsQueryType>(
		getRelayEnvironment(),
		PageOwnershipByLineWithCollaboratorsDropdownContentQuery,
		getContentCollaboratorsQueryVariables({
			cloudId,
			contentId,
			spaceKey,
		}),
		{ fetchPolicy: 'store-or-network' },
	).toPromise();
